module.exports = __webpack_public_path__ + "static/media/reward-s.7941e04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/reward-s.png
// module id = 1869
// module chunks = 0